<template>
  <Head title="Jobs" />
  <div
    class="max-w-7xl mx-auto my-8 bg-white rounded shadow divide-y transition-colors"
  >
    <JobCard
      v-for="job in pageData"
      :job="job"
      :key="job.id"
      class="hover:bg-gray-50 transition"
    />

    <div class="py-4 flex justify-center">
      <Pagination :links="jobs.links" />
    </div>
  </div>
</template>

<script>
import { Head } from "@inertiajs/inertia-vue3";

import JobCard from "@/components/Jobs/JobCard";
import Pagination from "@/components/Pagination";

export default {
  props: {
    jobs: Object,
  },

  computed: {
    pageData() {
      return this.jobs.data;
    },
  },

  components: {
    Head,
    JobCard,
    Pagination,
  },
};
</script>
